<template>
    <form
        id="rsvp-form"
        @submit.prevent="onSubmit"
    >
        <h2 v-if="!saved">Let us know you'll be there!</h2>
        <div
            v-if="failed"
            class="failure-message"
        >
            <p>Whoops! Something went wrong. Please email <a href="mailto:thejordanforeman@gmail.com">thejordanforeman@gmail.com</a> or try again later</p>
        </div>
        <div
            v-if="saving"
            class="saving-spinner"
        >
            <spinner />
        </div>
        <div
            v-if="saved"
            class="success-message"
        >
            <p v-if="isAttending">Thanks! We'll see you soon!</p>
            <p v-else>Sorry you can't make it. We'll miss you!</p>
        </div>
        <div
            v-if="!saved"
            class="form-contents"
        >
            <div class="form-row">
                <div class="form-control">
                    <label for="name">
                        Name
                    </label>
                    <input
                        v-model="name"
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your name"
                        required
                    />
                </div>
            </div>
            <div class="form-row">
                <div class="form-control form-control__radio">
                    <input
                        id="attending"
                        name="is-attending"
                        value="is-attending"
                        type="radio"
                        v-model="attending"
                    />
                    <label for="attending">
                        I'll be there!
                    </label>
                </div>
                <div class="form-control form-control__radio">
                    <input
                        id="not-attending"
                        name="is-attending"
                        value="not-attending"
                        type="radio"
                        v-model="attending"
                    />
                    <label for="not-attending">
                        I'm unable to attend
                    </label>
                </div>
            </div>
            <div class="form-row">
                <div class="form-control">
                    <label for="message">
                        Additional Info (allergies, etc)
                    </label>
                    <textarea
                        v-model="message"
                        rows="4"
                        id="message"
                        name="message"
                    >
                </textarea>
                </div>
            </div>
            <div class="form-row">
                <div class="form-control number">
                    <label for="adults">
                        Adults Attending
                    </label>
                    <input
                        v-model="adults"
                        id="adults"
                        name="adults"
                        type="number"
                        placeholder="0"
                        min="0"
                        max="10"
                        required
                    />
                </div>
                <div class="form-control number">
                    <label for="children">
                        Children Attending
                    </label>
                    <input
                        v-model="children"
                        id="children"
                        name="children"
                        type="number"
                        placeholder="0"
                        min="0"
                        max="10"
                        required
                    />
                </div>
            </div>
            <div class="form-row form-message">
                <p>You should see a confirmation message if RSVP was successful. If you have any troubles, please email Jordan at <a href="mailto:thejordanforeman@gmail.com">thejordanforeman@gmail.com</a></p>
            </div>
            <div class="form-row">
                <div class="form-control">
                    <input type="submit" value="RSVP"/>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import Spinner from './spinner.vue';

const API_URL = 'https://api.maggiandjordan.com';
const API_KEY = 'Tgz9tchQKs96eAp3Znj1T1nhIPhG4kONkygs2Lx9';
const ATTENDING = 'is-attending';

function saveSuccess() {
    this.saving = false;
    this.saved = true;
}

function saveFailure() {
    this.saving = false;
    this.failed = true;
}

function handleResponse(response) {
    if (response && response.data && response.data.errorMessage) {
        throw response.data.errorMessage;
    }
}

export default {
    name: 'rsvp-form',
    components: {
        'spinner': Spinner
    },
    data: function() {
        return {
            name: '',
            adults: 0,
            children: 0,
            message: 'anything we need to know?',
            attending: ATTENDING,
            saving: this.saving,
            failed: this.failed,
            saved: this.saved
        };
    },
    computed: {
        isAttending: function() {
            return (this.attending === ATTENDING);
        }
    },
    methods: {
        onSubmit: function () {
            this.saving = true;
            this.failed = false;

            const postData = {
                name: this.name,
                adults: this.adults,
                children: this.children,
                message: this.message,
                attending: this.isAttending
            };

            axios({
                method: 'post',
                url: `${API_URL}/rsvp`,
                data: postData,
                headers: {
                    'x-api-key': API_KEY
                }
            })
            .then(handleResponse)
            .then(saveSuccess.bind(this))
            .catch(saveFailure.bind(this));
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/rsvp-form.vue?4c18c169